import React from 'react';

/**
 * Stylised outline of the Nordkette range above Innsbruck, drawn as map linework
 * (DESIGN.md → signature). The shape is hand-drawn, not surveyed; the peak
 * positions follow the real summits, west → east.
 */

const W = 1440;
const H = 220;
const BASE = 210; // valley floor in viewBox units

// Ridge silhouette, west → east.
const RIDGE: [number, number][] = [
    [0, 160], [60, 146], [120, 126], [170, 100], [210, 74], [240, 52], [260, 37],
    [285, 56], [310, 64], [340, 82], [370, 76], [400, 92], [430, 84], [470, 74],
    [510, 78], [540, 68], [560, 62], [585, 74], [610, 88], [640, 100], [670, 94],
    [700, 104], [730, 90], [760, 78], [790, 70], [820, 76], [850, 64], [880, 56],
    [905, 66], [930, 62], [960, 78], [990, 86], [1020, 74], [1050, 68], [1080, 60],
    [1110, 64], [1140, 54], [1160, 50], [1180, 46], [1205, 60], [1230, 74],
    [1270, 96], [1310, 114], [1350, 130], [1400, 146], [1440, 160],
];

// Summit markers (Brandjoch, Frau Hitt, Hafelekarspitze, Rumer Spitze).
const PEAKS: [number, number][] = [[260, 37], [560, 62], [880, 56], [1180, 46]];

// Lower contour lines: the ridge pulled toward the valley floor.
const CONTOUR_STEPS = [0.32, 0.58, 0.8];

const toPath = (pts: [number, number][]) =>
    pts.map(([x, y], i) => `${i ? 'L' : 'M'}${x} ${y.toFixed(1)}`).join(' ');

const contour = (f: number) =>
    toPath(RIDGE.map(([x, y]) => [x, y + (BASE - y) * f] as [number, number]));

export const NordketteRidge: React.FC = () => (
    <div className="w-full max-w-[1920px] mx-auto overflow-hidden">
        <svg
            viewBox={`0 0 ${W} ${H}`}
            preserveAspectRatio="xMidYMax slice"
            className="block w-full h-[190px] lg:h-auto lg:aspect-[1440/220]"
            role="img"
            aria-label="Outline of the Nordkette range above Innsbruck"
        >
            {CONTOUR_STEPS.map(f => (
                <path
                    key={f}
                    d={contour(f)}
                    fill="none"
                    className="stroke-contour"
                    strokeWidth={1}
                    strokeLinejoin="round"
                    vectorEffect="non-scaling-stroke"
                />
            ))}

            <path
                d={toPath(RIDGE)}
                fill="none"
                className="stroke-ink"
                strokeWidth={1.75}
                strokeLinejoin="round"
                vectorEffect="non-scaling-stroke"
            />

            {PEAKS.map(([x, y]) => (
                <path key={x} d={`M${x - 5} ${y - 6} L${x + 5} ${y - 6} L${x} ${y - 14} Z`} className="fill-ink" />
            ))}
        </svg>
    </div>
);
